<template>
  <div class="flex bg-white px-5 py-[21px]">
    <!-- アイコン -->
    <img
      :src="userIcon"
      @error="guestImgOnError"
      class="h-10 w-10 rounded-[20px] shadow-icon mr-4"
    />
    <div class="flex-1 min-w-0 text-left break-words">
      <!-- ユーザー名 -->
      <div class="flex items-center relative bottom-1 mb-0.5">
        <div>
          <span class="text-W7 text-[13px]">{{ contributor.name }}</span>
          <span class="text-W3 text-[13px]">さん</span>
        </div>
        <div class="ml-1 w-3">
          <img src="@/assets/Icon_Check_blue_public.svg" class="h-2 w-2" />
        </div>
      </div>
      <!-- 説明 -->
      <div
        ref="description"
        class="h-max text-W4 text-[13px] leading-[19.5px] break"
        :class="{bodyLineBreak: !showFullText}"
      >
        {{ contributor.description }}
      </div>
      <div
        v-if="isOverflowing && !showFullText"
        class="text-gray400 text-[13px] leading-[17.5px] text-W4"
        @click.stop="onClickShowMore()"
      >
        続きを見る
      </div>
      <!-- 公式サイト -->
      <div
        v-if="hasContributorUrl"
        class="flex text-W4 text-[11px] leading-[7px] mt-2.5"
      >
        <img
          src="@/assets/common/Icon_Url_Head.svg"
          class="h-2 w-4 mt-0.5 mr-2"
        />
        <div
          class="text-W4 text-primary text-[11px] break-all text-left"
          @click="openUrl()"
        >
          {{ contributor.url }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NativeUtil from '@/mixins/nativeUtil.js'
const UserDescription = {
  name: 'UserDescription',
  data() {
    return {
      isOverflowing: false, // 説明文が表示領域からはみ出すか
      showFullText: false, // 全説明文表示の有効可否
    }
  },
  props: {
    // 投稿者情報
    contributor: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    // 説明文の全文表示可否を判定
    this.checkDescriptionOverflow()
  },
  computed: {
    /**
     * 投稿者アイコン
     */
    userIcon() {
      // ユーザーアイコン未設定の場合、ゲストアイコンを表示
      if (this.contributor.img == '') {
        return require('@/assets/Icon_Guest.svg')
      }

      return this.contributor.img
    },
    /** 投稿者の公式URLの有無 */
    hasContributorUrl() {
      return this.contributor.url !== ''
    },
  },
  watch: {
    contributor: {
      deep: true,
      handler() {
        // 投稿者情報が変わったタイミングで、説明文の全文表示可否を再判定
        this.$nextTick(() => {
          this.checkDescriptionOverflow()
        })
      },
    },
  },
  methods: {
    /**
     * 説明文が表示し切れるかどうかを判断し、結果を保持
     */
    checkDescriptionOverflow() {
      const container = this.$refs.description
      this.isOverflowing = container.scrollHeight > container.clientHeight
    },

    /**
     * 本文押下時処理
     * 「続きを見る」が表示されている場合、本文を開く
     */
    onClickShowMore() {
      if (this.isOverflowing && !this.showFullText) {
        this.showFullText = true
      }
    },
    /**
     * 公式サイトのURLを別ブラウザで展開
     */
    async openUrl() {
      await NativeUtil.methods.openExternalUrl(this.contributor.url)
      NativeUtil.methods.sendJumpDokoikuContributorUrlLogEventForGA(
        this.contributor.contributorId,
        this.contributor.url
      )
    },
    /**
     * 投稿者画像読み込み失敗時処理
     * @param {Event} event イベント情報
     */
    guestImgOnError(event) {
      // 読み込み失敗した場合は、ゲストアイコンを表示する
      const guestIcon = require('@/assets/Icon_Guest.svg')
      event.target.src = guestIcon
    },
  },
}
export default UserDescription
</script>
<style scooped>
.bodyLineBreak {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.break {
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>
